/* unplugin-vue-components disabled */import { render } from "./HomeView.vue?vue&type=template&id=1a530388&scoped=true"
import script from "./HomeView.vue?vue&type=script&lang=js"
export * from "./HomeView.vue?vue&type=script&lang=js"

import "./HomeView.vue?vue&type=style&index=0&id=1a530388&lang=scss&scoped=true"

import exportComponent from "E:\\普通网页项目\\奇力士官网新版\\officialwebsite\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1a530388"]])

export default __exports__